export default "__VITE_ASSET__6MPcGrBS__"